var $4ca1fa892b542e2f$exports = {};
const $4ca1fa892b542e2f$var$refer = new URL(document.referrer || 'https://example.com');
const $4ca1fa892b542e2f$var$our_host = window.location.origin;
const $4ca1fa892b542e2f$var$their_host = $4ca1fa892b542e2f$var$refer.origin;
if ($4ca1fa892b542e2f$var$our_host !== $4ca1fa892b542e2f$var$their_host && !window.location.search.includes('no_default')) try {
    const cfg = JSON.parse(localStorage.getItem('schedule'));
    const page = cfg.default_page || '/';
    if (!window.location.pathname !== page) window.location.href = `${page}${window.location.search}`;
} catch  {}


//# sourceMappingURL=frontend.198ff59f.js.map
